import { render, staticRenderFns } from "./solicitacao-visualizacao.vue?vue&type=template&id=52579e32&"
import script from "./solicitacao-visualizacao.vue?vue&type=script&lang=js&"
export * from "./solicitacao-visualizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports